import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-horizontal-rule",
  templateUrl: "./med-icon-horizontal-rule.component.html",
})
export class MedIconHorizontalRuleComponent extends SvgMixinComponent {}
